var EnableSmartFilterButton = /** @class */ (function () {
    function EnableSmartFilterButton() {
        this.initEvents();
    }
    EnableSmartFilterButton.prototype.initEvents = function () {
        var $input = jQuery('#acp_enable_smart_filtering_button > input');
        $input.change(function () {
            jQuery.post(ajaxurl, {
                action: 'acp_enable_smart_filtering_button',
                value: $input.is(':checked'),
                layout: AC.layout,
                list_screen: AC.list_screen,
                _ajax_nonce: AC.ajax_nonce
            });
        });
    };
    return EnableSmartFilterButton;
}());
export default EnableSmartFilterButton;
